var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"ButtonNext",attrs:{"disabled":_vm.disabled},on:{"click":_vm.nextStepSCORM2}},[_vm._v("Salto")])}
var staticRenderFns = []

export { render, staticRenderFns }